<template>
    <div :class="['cars-list-item', { 'cars-list-item--active': isActive}]">
        <div class="cars-list-item__center">
            <CarDetailsSection :car="car" />
        </div>

        <div class="cars-list-item__right">
            <div class="cars-list-item__right-section">
                <UIInput
                    id="starting_price"
                    v-model="formStartPrice"
                    label="Стартовая цена"
                    :is-currency="true"
                />

                <UISimpleButton
                    v-if="isActive"
                    button-type="inAuction"
                    @click="handleRemoveCar"
                >
                    <template #icon>
                        <img v-svg-inline src="@/assets/icons/ui/done.svg" />
                    </template>
                    В аукционе
                </UISimpleButton>

                <UISimpleButton
                    v-else
                    @click="handleAddCar"
                >
                    В аукцион
                </UISimpleButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { PropType, ref } from 'vue';

    import { Car } from '@/types/car.type.ts';

    import UIInput from '@/components/ui/UIInput/UIInput.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    import CarDetailsSection from '@/components/auction/CreateAuction/CarDetailsSection/CarDetailsSection.vue';

    const { car, isActive } = defineProps({
        isActive: {
            type: Boolean,
            default: false,
        },
        car: {
            type: Object as PropType<Car>,
            required: true,
        },
    });

    const emit = defineEmits<{
        (e: 'added', car: Car): void,
        (e: 'removed', car: Car): void,
    }>();

    const formStartPrice = ref<string>(`${car.start_price}`);

    function handleAddCar(): void {
        emit('added', {
            ...car,
            start_price: formStartPrice.value.length > 0 ? parseInt(formStartPrice.value) : 0,
        });
    }

    function handleRemoveCar(): void {
        emit('removed', {
            ...car,
            start_price: formStartPrice.value.length > 0 ? parseInt(formStartPrice.value) : 0,
        });
    }
</script>

<style scoped lang="scss">
    @use './CarListItem.scss' as *;
</style>
